import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import {
  FORMAT_WORDS,
  DURATION_FORMAT_ITEMS,
} from "%/dynamic-components/render-engine/helpers/duration-format";

export default class DurationFormat extends BaseOption {
  static userInterfaceComponent = {
    label: "Duration Format",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      options: DURATION_FORMAT_ITEMS,
    },
  };

  // The existing shape stays the default, so every already-authored element
  // renders exactly what it rendered before this option existed.
  static defaultValue = FORMAT_WORDS;

  static convertConfigValueToCompiledValue(configValue) {
    return configValue;
  }
}
